const SubscriptionDashboard = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.39935 10.7001C3.1549 10.2779 2.97157 9.84453 2.84935 9.40008C2.72713 8.95564 2.66602 8.50008 2.66602 8.03342C2.66602 6.54453 3.18268 5.27786 4.21602 4.23341C5.24935 3.18897 6.51046 2.66675 7.99935 2.66675H8.11602L7.04935 1.60008L7.98268 0.666748L10.6493 3.33341L7.98268 6.00008L7.04935 5.06675L8.11602 4.00008H7.99935C6.88824 4.00008 5.94379 4.39175 5.16602 5.17508C4.38824 5.95842 3.99935 6.91119 3.99935 8.03342C3.99935 8.3223 4.03268 8.60564 4.09935 8.88342C4.16602 9.16119 4.26602 9.43342 4.39935 9.70008L3.39935 10.7001ZM8.01602 15.3334L5.34935 12.6667L8.01602 10.0001L8.94935 10.9334L7.88268 12.0001H7.99935C9.11046 12.0001 10.0549 11.6084 10.8327 10.8251C11.6105 10.0417 11.9993 9.08897 11.9993 7.96675C11.9993 7.67786 11.966 7.39453 11.8993 7.11675C11.8327 6.83897 11.7327 6.56675 11.5993 6.30008L12.5993 5.30008C12.8438 5.7223 13.0271 6.15564 13.1493 6.60008C13.2716 7.04453 13.3327 7.50008 13.3327 7.96675C13.3327 9.45564 12.816 10.7223 11.7827 11.7667C10.7493 12.8112 9.48824 13.3334 7.99935 13.3334H7.88268L8.94935 14.4001L8.01602 15.3334Z"
      fill="currentColor"
    />
  </svg>
);

export default SubscriptionDashboard;
